import { formatPrice } from '~utils/number';

export const getTotalPrice = ({ shoppingCart, redeemedCode, isTipAllowed, currentTip }) => {
  const { useGiftCard, isGiftCard } = redeemedCode;
  const { total, subtotal, delivery } = shoppingCart;
  const shoppingCartTotal = !isGiftCard || useGiftCard ? total : subtotal + delivery;
  const tip = isTipAllowed ? currentTip : 0;
  return formatPrice(shoppingCartTotal + tip);
};
